import React from 'react';
import StickyFooter from '@framework/ui/Organisms/StickyFooter';
import { footerConfig } from './config';

const Footer = () => (
  <StickyFooter
    config={ footerConfig() }
  />
);

export default Footer;
